export default "__VITE_ASSET__CQY$oUIv__"